import { render, staticRenderFns } from "./WorkSpeedDial.vue?vue&type=template&id=58c15570&scoped=true"
import script from "./WorkSpeedDial.vue?vue&type=script&lang=js"
export * from "./WorkSpeedDial.vue?vue&type=script&lang=js"
import style0 from "./WorkSpeedDial.vue?vue&type=style&index=0&id=58c15570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c15570",
  null
  
)

export default component.exports